export enum SortDirectionEnum {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
}
